import styled from "@emotion/styled";

const Divider = styled.hr`
  opacity: 0.2;
  margin: 1em 0;
`;

export default Divider;
